// extracted by mini-css-extract-plugin
export default {"editMenu":"EditMenu_editMenu__Ef+9z","listItem":"EditMenu_listItem__h+lWw","disabled":"EditMenu_disabled__FuGdo","link":"EditMenu_link__eR5+j"};